/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as TabsRouteImport } from './routes/_tabs'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TabsProfileRouteImport } from './routes/_tabs.profile'
import { Route as TabsLogRouteImport } from './routes/_tabs.log'
import { Route as TabsHomeRouteImport } from './routes/_tabs.home'
import { Route as TabsGraphRouteImport } from './routes/_tabs.graph'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const TabsRoute = TabsRouteImport.update({
  id: '/_tabs',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TabsProfileRoute = TabsProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => TabsRoute,
} as any)
const TabsLogRoute = TabsLogRouteImport.update({
  id: '/log',
  path: '/log',
  getParentRoute: () => TabsRoute,
} as any)
const TabsHomeRoute = TabsHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => TabsRoute,
} as any)
const TabsGraphRoute = TabsGraphRouteImport.update({
  id: '/graph',
  path: '/graph',
  getParentRoute: () => TabsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/sign-in': typeof SignInRoute
  '/terms': typeof TermsRoute
  '/graph': typeof TabsGraphRoute
  '/home': typeof TabsHomeRoute
  '/log': typeof TabsLogRoute
  '/profile': typeof TabsProfileRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/sign-in': typeof SignInRoute
  '/terms': typeof TermsRoute
  '/graph': typeof TabsGraphRoute
  '/home': typeof TabsHomeRoute
  '/log': typeof TabsLogRoute
  '/profile': typeof TabsProfileRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_tabs': typeof TabsRouteWithChildren
  '/onboarding': typeof OnboardingRoute
  '/privacy': typeof PrivacyRoute
  '/sign-in': typeof SignInRoute
  '/terms': typeof TermsRoute
  '/_tabs/graph': typeof TabsGraphRoute
  '/_tabs/home': typeof TabsHomeRoute
  '/_tabs/log': typeof TabsLogRoute
  '/_tabs/profile': typeof TabsProfileRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/onboarding'
    | '/privacy'
    | '/sign-in'
    | '/terms'
    | '/graph'
    | '/home'
    | '/log'
    | '/profile'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/onboarding'
    | '/privacy'
    | '/sign-in'
    | '/terms'
    | '/graph'
    | '/home'
    | '/log'
    | '/profile'
  id:
    | '__root__'
    | '/'
    | '/_tabs'
    | '/onboarding'
    | '/privacy'
    | '/sign-in'
    | '/terms'
    | '/_tabs/graph'
    | '/_tabs/home'
    | '/_tabs/log'
    | '/_tabs/profile'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  TabsRoute: typeof TabsRouteWithChildren
  OnboardingRoute: typeof OnboardingRoute
  PrivacyRoute: typeof PrivacyRoute
  SignInRoute: typeof SignInRoute
  TermsRoute: typeof TermsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_tabs': {
      id: '/_tabs'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof TabsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_tabs/profile': {
      id: '/_tabs/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof TabsProfileRouteImport
      parentRoute: typeof TabsRoute
    }
    '/_tabs/log': {
      id: '/_tabs/log'
      path: '/log'
      fullPath: '/log'
      preLoaderRoute: typeof TabsLogRouteImport
      parentRoute: typeof TabsRoute
    }
    '/_tabs/home': {
      id: '/_tabs/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof TabsHomeRouteImport
      parentRoute: typeof TabsRoute
    }
    '/_tabs/graph': {
      id: '/_tabs/graph'
      path: '/graph'
      fullPath: '/graph'
      preLoaderRoute: typeof TabsGraphRouteImport
      parentRoute: typeof TabsRoute
    }
  }
}

interface TabsRouteChildren {
  TabsGraphRoute: typeof TabsGraphRoute
  TabsHomeRoute: typeof TabsHomeRoute
  TabsLogRoute: typeof TabsLogRoute
  TabsProfileRoute: typeof TabsProfileRoute
}

const TabsRouteChildren: TabsRouteChildren = {
  TabsGraphRoute: TabsGraphRoute,
  TabsHomeRoute: TabsHomeRoute,
  TabsLogRoute: TabsLogRoute,
  TabsProfileRoute: TabsProfileRoute,
}

const TabsRouteWithChildren = TabsRoute._addFileChildren(TabsRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  TabsRoute: TabsRouteWithChildren,
  OnboardingRoute: OnboardingRoute,
  PrivacyRoute: PrivacyRoute,
  SignInRoute: SignInRoute,
  TermsRoute: TermsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
